export default "__VITE_ASSET__DlwzLBlZ__"